import React from 'react';
import { withTranslation } from 'react-i18next';

const PILL_SLOTS = 5;

function GoalSummaryCellComponent({ goals, breakdown, isExpanded, isClickable, t }) {
    if (!goals || goals.length === 0) {
        return <span className="goals-empty">—</span>;
    }

    const pills = [];
    for (let i = 0; i < PILL_SLOTS; i++) {
        const g = goals[i];
        pills.push(g ? (g.alert_level || 'normal') : 'empty');
    }

    const breakdownRows = [
        { key: 'ok',     label: t('business_unit_budget_history.summary_ok'),     count: breakdown?.ok ?? 0,     cls: '-ok' },
        { key: 'warn',   label: t('business_unit_budget_history.summary_warn'),   count: breakdown?.warn ?? 0,   cls: '-warn' },
        { key: 'critic', label: t('business_unit_budget_history.summary_critic'), count: breakdown?.critic ?? 0, cls: '-critic' },
    ].filter(r => r.count > 0);

    return (
        <div className={`goal-summary ${isExpanded ? '-open' : ''}`}>
            <span className="goal-summary__count">
                <strong>{goals.length}</strong>
                <small>{t('business_unit_budget_history.objectives_label')}</small>
            </span>
            <div className="info-icon-container goal-summary__pills-wrap">
                <span className="goal-summary__pills" aria-hidden="true">
                    {pills.map((lvl, i) => (
                        <span key={i} className={`goal-summary__pill -${lvl}`} />
                    ))}
                </span>
                {breakdownRows.length > 0 && (
                    <div className="warning-tooltip">
                        <div className="warning-tooltip-body">
                            {breakdownRows.map(row => (
                                <p key={row.key} className="warning-tooltip-text goal-summary__breakdown-row">
                                    <span className={`goal-summary__breakdown-dot ${row.cls}`} />
                                    <strong>{row.count}</strong> {row.label}
                                </p>
                            ))}
                        </div>
                    </div>
                )}
            </div>
            {isClickable && (
                <span className={`goal-summary__caret ${isExpanded ? '-open' : ''}`}>▾</span>
            )}
        </div>
    );
}

export const GoalSummaryCell = withTranslation()(GoalSummaryCellComponent);
